var _defs, _style;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFeatCarbonAlarmOff = function SvgFeatCarbonAlarmOff(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 15.28 15.27",
    width: 15.28,
    height: 15.27,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs191"
  })), _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css",
    id: "style182"
  }, "\n\t.st0{fill-rule:evenodd;clip-rule:evenodd;}\n")), /*#__PURE__*/React.createElement("g", {
    id: "g186",
    style: {
      fill: "#7f7f7f",
      fillOpacity: 1,
      stroke: "#7f7f7f",
      strokeWidth: 0.2,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(-0.61,-0.33)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0.74,2.74 1.05,1.04 v 9.03 c 0,0.86 0.66,1.56 1.52,1.62 h 9.12 l 1.05,1.05 C 13.39,15.49 13.3,15.5 13.21,15.5 H 13.1 3.4 C 1.96,15.5 0.77,14.37 0.71,12.93 V 3.12 c 0,-0.13 0.01,-0.26 0.03,-0.38 z m 0.89,-2.15 14,14 -0.76,0.75 -14,-14 c 0,0 0.76,-0.75 0.76,-0.75 z M 13.1,0.43 c 1.44,0 2.63,1.13 2.69,2.57 v 9.81 c 0,0.13 -0.01,0.25 -0.03,0.38 L 14.71,12.15 V 3.12 C 14.71,2.26 14.05,1.56 13.19,1.5 H 4.07 L 3.03,0.46 C 3.11,0.44 3.21,0.43 3.3,0.43 H 3.4 Z M 5.61,8.5 c 0.22,1.06 1.04,1.88 2.1,2.1 v 1.09 C 6.06,11.45 4.76,10.15 4.52,8.5 c 0,0 1.09,0 1.09,0 z m 3.18,2.29 0.73,0.73 C 9.28,11.6 9.04,11.66 8.79,11.7 Z M 11.07,8.5 h 0.91 C 11.94,8.75 11.88,9 11.8,9.23 Z M 8.79,4.23 c 1.65,0.24 2.95,1.54 3.19,3.19 H 10.89 C 10.67,6.36 9.85,5.54 8.79,5.32 Z M 4.7,6.7 5.43,7.43 H 4.52 C 4.56,7.17 4.62,6.93 4.7,6.7 Z M 7.71,4.23 V 5.14 L 6.99,4.41 C 7.22,4.33 7.46,4.27 7.71,4.23 Z m 4.31,-0.57 c 0.3,0 0.54,0.24 0.54,0.54 0,0.3 -0.24,0.54 -0.54,0.54 -0.3,0 -0.54,-0.24 -0.54,-0.54 0,-0.3 0.24,-0.54 0.54,-0.54 z",
    id: "path184",
    style: {
      fill: "#7f7f7f",
      fillOpacity: 1,
      stroke: "#7f7f7f",
      strokeWidth: 0.2,
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  })));
};
export default SvgFeatCarbonAlarmOff;